import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgManufacturing = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0504 10.6064L2.97934 17.6775C2.19829 18.4585 2.19829 19.7249 2.97934 20.5059C3.76038 21.287 5.02671 21.287 5.80776 20.5059L12.8788 13.4349",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1923 13.7998L21.0706 17.6781C21.8517 18.4591 21.8517 19.7255 21.0706 20.5065C20.2896 21.2876 19.0232 21.2876 18.2422 20.5065L12.0337 14.2981",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.73239 5.90377L4.61107 6.61088L2.48975 3.07535L3.90396 1.66113L7.4395 3.78245L6.73239 5.90377ZM6.73239 5.90377L9.56261 8.734",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0501 10.6066C9.20625 8.45363 9.37122 5.62865 11.1108 3.88914C12.8503 2.14962 16.0605 1.76782 17.8283 2.82848L14.7876 5.86915L14.505 8.98019L17.616 8.69758L20.6567 5.6569C21.7174 7.42467 21.3356 10.6349 19.5961 12.3744C17.8565 14.1139 15.0316 14.2789 12.8786 13.435",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgManufacturing;
